<template>
  <div>
    <h1 class="align-center">Edit & Order Image Set</h1>
    <spinner v-if="loading"></spinner>
    <div class="collection-edit" v-else>
      <div class="collection-edit__inner">
        <image-edit-line key="coverImage" :image="form.image_set" :is-cover="true"
                         :replace-image-url="imageSetImageApi.replace_image_set_image_url"
                         :art-subjects="artSubjects"
                         :image-set="imageSet"
                         :styles="styles"
                         :edit-illustration="editImageSet"></image-edit-line>

        <div class="collection-edit__list" id="ui-sortable">
          <div v-for="(image, index) in form.images" :data-id="image.id" class="sortable-item">
            <image-edit-line :key="index" :image="image"
                             :replace-image-url="imageApi.replace_image_set_image_url"
                             :art-subjects="artSubjects"
                             :delete-image-callback="deleteImage"
                             :image-set="imageSet"
                             :styles="styles"
                             :edit-illustration="editIllustration"></image-edit-line>
          </div>
        </div>

        <div class="collection-edit__btns">
          <spinner v-if="saving"></spinner>
          <div v-else>
            <button class="collection-edit__btn _save" @click="save" style="padding: 0; border: 3px solid #6f1b57">Save
              Image Set
            </button>
            <router-link :to="{name: 'portfolio.collection.add-images', params: {id}}"
                         class="collection-edit__btn _add-image">Add further images
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imageSetApi from './../../../../api/image-set';
import imageApi from './../../../../api/image';
import imageSetImageApi from './../../../../api/image-set/images';
import Form from './../../../../Form';
import ImageEditLine from './ImageEditLine';
import artSubjectApi from './../../../../api/art-subject';
import searchTermApi from './../../../../api/search-term';
import * as constants from './../constants';

export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    }
  },
  components: {
    'image-edit-line': ImageEditLine,
  },
  data() {
    return {
      form: null,
      imageSetImageApi,
      imageApi,
      artSubjects: null,
      imageSet: null,
      styles: null,
      saving: false,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    initSortable() {
      let self = this;

      setTimeout(() => {
        $('#ui-sortable').sortable({
          stop: function () {
            let imageSetImageIds = [];

            $('#ui-sortable .sortable-item').each(function () {
              imageSetImageIds.push($(this).data('id'));
            });

            self.changeOrder(imageSetImageIds);
          }
        });
      }, 1000);
    },
    changeOrder(imageSetImageIds) {
      imageSetImageApi.changeOrder(this.id, imageSetImageIds).then(() => {
        toastr.success('Updated successfully');
      }).catch(() => {
        toastr.error('Something went wrong. Please try again later');
      });
    },
    getFirstErrorFromResponse(errors) {
      let firstErrorKey = Object.keys(errors)[0];

      return errors[firstErrorKey][0];
    },
    handleError(errorObject) {
      if (errorObject.status != 422) {
        toastr.error('Something went wrong. Please try again later');
        return;
      }

      toastr.error(this.getFirstErrorFromResponse(errorObject.data.errors));
    },
    editIllustration(data) {
      imageApi.updateWithAttachment(data.id, data).then(() => {
        toastr.success('Edited successfully');
        $('.expand-area[data-id="' + data.file_id + '"]').slideToggle();
      }).catch((error) => {
        this.handleError(error.response);
      });
    },
    editImageSet(data) {
      imageSetApi.updateWithAttachment(this.imageSet.id, data).then(() => {
        $('.expand-area[data-id="' + data.file_id + '"]').slideToggle();
        toastr.success('Edited successfully');
      }).catch((error) => {
        this.handleError(error.response);
      });
    },
    fetchData() {
      imageSetApi.fetch(this.id, [
        'images.artSubjects',
        'images.styles',
        'artSubjects',
        'book',
        'styles',
      ]).then((imageSet) => {

        this.imageSet = imageSet;
        let images = imageSet.images.map((image) => {
          return {
            id: image.id,
            file_id: image.image.id,
            public_path: image.scaled100,
            title: image.title,
            description: image.description,
            keywords: image.keywords,
            art_subjects: image.art_subjects.map(subject => subject.id),
            styles: image.styles.map(style => style.id),
          };
        });

        this.form = new Form({
          image_set_id: this.id,
          image_set: {
            file_id: imageSet.cover_image.id,
            public_path: imageSet.cover_image.scaled100,
            title: imageSet.title,
            description: imageSet.description,
            keywords: imageSet.keywords,
            art_subjects: imageSet.art_subjects.map(subject => subject.id),
            styles: imageSet.styles.map(style => style.id),
          },
          images,
        });

        this.initSortable();
      });

      searchTermApi.all().then((searchTerms) => {
        this.prepareStyles(searchTerms);
      });

      artSubjectApi.all().then((artSubjects) => {
        this.artSubjects = artSubjects;
      });
    },
    save() {
      this.saving = true;
      imageSetImageApi.updateImageSetImages(this.form, this.form.image_set_id).then((data) => {
        toastr.success('Edited successfully');

        setTimeout(() => {
          location.href = '/profile/portfolio';
        }, 2000);

        this.saving = false;
      }).catch(() => {
        this.saving = false;
      });
    },
    prepareStyles(searchTerms) {
      this.styles = searchTerms.filter((searchTerm) => searchTerm.dictionary_id == constants.STYLES_DICTIONARY_ID);
    },
    deleteImage(id) {
      imageSetImageApi.remove(id).then(() => {
        toastr.success('Deleted successfully!');

        let imageIndex = this.form.images.findIndex(image => image.id === id);
        if (imageIndex === -1) return;

        this.form.images.splice(imageIndex, 1);
      });
    },
  },
  computed: {
    loading() {
      return !this.form || !this.artSubjects || !this.styles;
    },
  }
};
</script>

<style lang="scss">
  .collection-edit {
    max-width: 800px;
    margin: 0 auto;

    .preloader {
      display: block;
      width: 50px;
      height: 50px;
      margin: 0 auto;
      border-top: 9px solid rgba(0, 0, 0, 0.2);
      border-right: 9px solid rgba(0, 0, 0, 0.2);
      border-bottom: 9px solid rgba(0, 0, 0, 0.2);
      border-left: 9px solid #6E1B56;
      border-radius: 50%;
      animation: load 1.1s infinite linear;
    }
  }

  @keyframes load {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  .collection-edit__item {
    padding: 30px 0;
    border-bottom: 2px solid #ccc;
  }

  .collection-edit__item-inner {
    display: table;
    width: 100%;
  }

  .collection-edit__item-drag-trigger {
    display: table-cell;
    width: 50px;
    vertical-align: middle;

    span {
      display: block;
      width: 8px;
      height: 8px;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 5px;
      border-radius: 50%;
      background: #555555;

      &:last-of-type { margin-bottom: 0; }
    }
  }
  .collection-edit__item-img {
    display: table-cell;
    width: 100px;
    vertical-align: middle;

    img {
      width: 100%;
    }
  }
  .collection-edit__item-btns {
    display: table-cell;
    width: calc(100% - 180px);
    padding-left: 30px;
    vertical-align: middle;
    font-size: 0;

    input[type="file"] {
      display: none;
    }
  }
  .collection-edit__item-hidden-img {
    display: none;
  }

  .collection-edit__item-btn {
    display: inline-block;
    width: 30%;
    margin-right: 5%;
    padding: 15px 0;
    border: 3px solid;
    border-radius: 5px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    white-space: nowrap;
    cursor: pointer;

    &:last-of-type { margin-right: 0; }

    &._purple {
      border-color: #6f1b57;
      background-color: #6f1b57;
      color: #fff;
    }
    &._gray {
      border-color: #c5c5c5;
      background-color: #c5c5c5;
      color: #555555;
    }
    &._transparent {
      border-color: #555555;
      background-color: transparent;
      color: #555555;
    }
  }

  .collection-edit__btns {
    margin-top: 30px;
  }

  .collection-edit__btn {
    display: block;
    width: 400px;
    max-width: 100%;
    margin: 10px auto;
    padding: 10px 0;
    border-radius: 5px;
    color: #fff;
    text-align: center;

    &._save {
      background-color: #6f1b57;
    }
    &._add-image {
      background-color: #c5c5c5;
    }
  }

  .collection-edit__item-desc {
    margin-top: 30px;
    padding-top: 30px;
    border-top: 2px solid #ccc;

    .save-btn {
      margin-top: 20px;
    }
  }

  .inline-loader {
    display: inline-block;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    border: 3px solid rgba(255,255,255,0.5);
    border-left-color: rgba(255,255,255,0.9);
    animation: loading-bar-spinner 0.6s linear;
    animation-iteration-count: infinite;
  }

  @keyframes loading-bar-spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
